import { render, staticRenderFns } from "./RegisterInd.vue?vue&type=template&id=f3c8c564"
import script from "./RegisterInd.vue?vue&type=script&lang=js"
export * from "./RegisterInd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports